import * as _ from 'underscore';
import { LoginUser } from './loginUser';
import { Templates } from '../compile';
import { BaseForm } from 'mappMvc/models/ui/forms';
import { ILoadable } from 'mappMvc/interfaces';
import { Notification, Util } from 'mappMvc/models';
import { ID } from '../const';
import { Size, ApplicationConfig } from 'mappMvc/const';
import { KeyCode } from 'mappMvc/enums';
import { ModalUtil, ConfirmModal } from 'mappMvc/models/modal';
import { NotificationElement, Label, Combobox, Button, LabelEdit } from 'mappMvc/models/ui/uiElements';
import { LocalizationClient } from 'mappClient/clients';
import { IAvailableLocalization } from 'mappClient/models';
import { Localization } from 'mappMvc/compile';
import Theming from './utils/theming';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { UserSettingsPanelModalComponent } from './modal/';
import { UserSettingsPropertyType } from './enums/userSettingsPropertyType';
import { Event } from 'mappMvc/models';
import { IEvent } from 'mappMvc/interfaces';

export class Header implements ILoadable {
	public user: LoginUser;
	public template: KnockoutObservable<string>;
	private form: BaseForm;
	private settingsCss: KnockoutObservable<string>;
	private notification: Notification;
	private escBindingActive: KnockoutObservable<boolean>;
	private email: KnockoutObservable<string>;
	private password: KnockoutObservable<string>;
	private password_confirm: KnockoutObservable<string>;
	private password_current: KnockoutObservable<string>;
	private hidePassword: KnockoutObservable<boolean>;
	private themingDefault: KnockoutObservable<string>;
	private languageReadonly: KnockoutObservable<string>;
	private language: KnockoutObservable<IAvailableLocalization>;
	private languageData: KnockoutObservableArray<IAvailableLocalization>;
	private confirmSubmit: ConfirmModal;

	private emailLabelEdit: LabelEdit;
	private languageEdit: LabelEdit;
	private changePasswordBtn: Button;
	private twoFactorBtn: Button;

	private onThemeChanged: Event<void>;
	public get ThemeChanged(): IEvent<void> {
		return this.onThemeChanged;
	}

	constructor(user: LoginUser) {

		user.updateUserInfo();

		this.onThemeChanged = new Event<void>();

		this.template = ko.observable<string>(Templates.header_bar);
		this.settingsCss = ko.observable<string>();
		this.user = user;
		this.email = ko.observable<string>(this.user.email());

		this.escBindingActive = ko.observable<boolean>(true);

		this.user.email.subscribe(newValue => this.email(newValue));

		this.password = ko.observable<string>().extend({
			stringEmptyNull: true
		});
		this.password_confirm = ko.observable<string>();
		this.password_current = ko.observable<string>();
		this.hidePassword = ko.observable<boolean>(true);

		if (localStorage.getItem('dark-theme')) {
			if (localStorage.getItem('dark-theme') === 'true') {
				this.themingDefault = ko.observable<string>('Dark');
			} else {
				this.themingDefault = ko.observable<string>('Light');
			}
		} else {
			this.themingDefault = ko.observable<string>('Automatic');
		}

		this.notification = new Notification();
		this.languageReadonly = ko.observable<string>();
		this.language = ko.observable<IAvailableLocalization>();
		this.languageData = ko.observableArray<IAvailableLocalization>();

		this.confirmSubmit = new ConfirmModal({
			closeLabel: Localization.Cancel,
			confirmLabel: Localization.Save,
			message: Localization.Confirm.LoggedOut,
			title: Localization.Login.Settings
		});

		this.confirmSubmit.Closed.subscribe(() => {
			this.closeSidePanel();
		});

		this.user.SettingsClicked.subscribe(() => {
			this.reload();
		});

		this.user.LogoutClicked.subscribe(() => {
			this.closeSidePanel();
		});

		this.form = new BaseForm({
			initDefaultCommands: false
		});
		this.form.addUIElement(new NotificationElement(null, null, this.notification));
		this.form.addUIElement(new Label(ID.User, Localization.Studio.User.User, this.user.userName));

		// ========================== Email Area =========================================

		if (!this.user.isManagementUser()) {

			this.emailLabelEdit = new LabelEdit(ID.LoginUserEmail, Localization.Login.Email, this.email, { css: 'text-overflow-ellipsis text-overflow-ellipsis-full-width', title: this.email });
			this.form.addUIElement(this.emailLabelEdit);

			this.emailLabelEdit.Clicked.subscribe(() => {
				ReactDOM.render(React.createElement(UserSettingsPanelModalComponent, { userId: this.user.userId, propertyType: UserSettingsPropertyType.Email, close: this.close, removeEventListener: this.removeEventListener }), document.querySelector('.mapp-modal-container'));
			});
		}

		// ========================== Email Area END =========================================

		// ========================== Loalization Area =========================================

		this.languageEdit = new LabelEdit(ID.LanguageCode, Localization.Studio.User.LanguageCode, this.languageReadonly, { css: 'text-overflow-ellipsis text-overflow-ellipsis-full-width', title: this.languageReadonly });
		this.form.addUIElement(this.languageEdit);

		this.languageEdit.Clicked.subscribe(() => {
			ReactDOM.render(React.createElement(UserSettingsPanelModalComponent, { userId: this.user.userId, propertyType: UserSettingsPropertyType.Language, languageData: { currentLanguage: this.language(), data: this.languageData() }, close: this.close, removeEventListener: this.removeEventListener }), document.querySelector('.mapp-modal-container'));
		});

		// ========================== Loalization Area END =========================================

		// ========================== Password Area =========================================	

		// Edit Password Button

		this.changePasswordBtn = new Button(ID.ChangePassword, Localization.Login.ChangePassword, '', { css: 'edit-password-btn' });
		this.form.addUIElement(this.changePasswordBtn);
		this.changePasswordBtn.Clicked.subscribe(() => {
			ReactDOM.render(React.createElement(UserSettingsPanelModalComponent, { userId: this.user.userId, propertyType: UserSettingsPropertyType.Password, close: this.close, removeEventListener: this.removeEventListener }), document.querySelector('.mapp-modal-container'));
		});

		// ========================== PASSWORD AREA END =========================================

		// ========================== TWO FACTOR AREA =========================================	

		// Edit Password Button
		if (!user.isTwoFactorAuthenticated()) {
			this.twoFactorBtn = new Button(ID.EnableTwoFactor, Localization.Login.EnableTwoFactor, '', { css: 'edit-password-btn' });
			this.form.addUIElement(this.twoFactorBtn);
			this.twoFactorBtn.Clicked.subscribe(() => {
				this.closeSidePanel();
				ReactDOM.render(React.createElement(UserSettingsPanelModalComponent, { userId: this.user.userId, propertyType: UserSettingsPropertyType.TwoFactor, close: this.close, removeEventListener: this.removeEventListener }), document.querySelector('.mapp-modal-container'));
			});
		} else {
			this.twoFactorBtn = new Button(ID.DisableTwoFactor, Localization.Login.DisableTwoFactor, '', { css: 'edit-password-btn' });
			this.form.addUIElement(this.twoFactorBtn);
			this.twoFactorBtn.Clicked.subscribe(() => {
				this.closeSidePanel();
				ReactDOM.render(React.createElement(UserSettingsPanelModalComponent, { userId: this.user.userId, propertyType: UserSettingsPropertyType.TwoFactorRemoval, close: this.close, removeEventListener: this.removeEventListener }), document.querySelector('.mapp-modal-container'));
			});
		}


		// ========================== TWO FACTOR AREA END =========================================

		// ========================== THEMING AREA =========================================

		this.form.addUIElement(
			new Combobox<string>(ID.AutomaticTheming, Localization.Studio.User.Theming, this.themingDefault, ['Automatic', 'Light', 'Dark'], {
				template: Templates.layouts_uiElements_noValidation,
				label: {
					size: Size._1_1
				}
			}, null, null)
		);

		this.themingDefault.subscribe(theme => {
			switch (theme) {
				case 'Automatic':
					localStorage.removeItem('dark-theme');
					break;
				case 'Light':
					localStorage.setItem('dark-theme', 'false');
					break;
				case 'Dark':
					localStorage.setItem('dark-theme', 'true');
					break;
			}
			Theming.toggleThemeFiles();
			this.onThemeChanged.notify();
		});

		// ========================== THEMING AREA END =========================================
	}

	private close = (logout: boolean) => {
		ReactDOM.unmountComponentAtNode(document.querySelector('.mapp-modal-container'));
		if (logout) {
			this.user.logout();
		}
	}

	private removeEventListener = () => {
		this.escBindingActive(false);
		this.closeSidePanel();
	}

	private closeSidePanel(): void {
		this.notification.hide();
		this.settingsCss(null);
		ModalUtil.overlay(false);
		Util.unbindKey(KeyCode.ESCAPE, this.closeSidePanel);
	}

	public loading(state: boolean): void {
		Util.loading(state, '.mapp-settings');
		document.getElementsByClassName('overlay')[0].addEventListener('click', () => {
			if (this.escBindingActive()) {
				this.closeSidePanel();
			}
		});
	}

	private reload(): void {

		if (this.user.isActiveDirectory()) {
			this.form.removeUIElement(this.emailLabelEdit);
			this.form.removeUIElement(this.changePasswordBtn);
		}

		this.escBindingActive(true);
		Util.setValue(null, this.password, this.password_confirm, this.password_current, this.language);
		this.hidePassword(true);
		this.form.hideValidationMessages();
		this.notification.hide();
		ModalUtil.overlay(true);
		this.settingsCss('on');
		this.loading(true);
		LocalizationClient.getAvailableLocalizations()
			.then(localizations => {
				this.reset(localizations);
				this.loading(false);
			})
			.catch((err) => {
				this.loading(false);
			});
	}

	private reset(localizations: IAvailableLocalization[]) {
		let userLanguage = _.findWhere(localizations, { name: ApplicationConfig.language() });
		let english = _.findWhere(localizations, { name: 'en' });

		if (!userLanguage) {
			userLanguage = english;
		}

		this.languageData(localizations);
		this.language(userLanguage);
		this.languageReadonly(userLanguage.displayName);

		if (!this.user.isManagementUser()) {
			this.email(this.user.email());
		}

		Util.bindKey(KeyCode.ESCAPE, this.closeSidePanel, this);
	}
}
